export default {
  path: "tLogin",
  component: () =>
    import(/* webpackChunkName: "token-login" */ "@/pages/passport/TokenLogin.vue"),
};
